<template>
  <b-container>
    <Headline title="Playlists" />
    <ObjectListTabs>
      <template slot-scope="{}">
        <b-nav-item :to="{name: 'fan-playlist-list', meta: { type: 'my'}}">My Playlists</b-nav-item>
        <b-nav-item :to="{name: 'fan-playlist-following', meta: { type: 'following'}}">Playlists Following</b-nav-item>
      </template>
      <template slot="cmd" slot-scope="{}">
        <b-button class="btn-rainbow" :to="{name: 'fan-playlist-create'}" size="sm">
          <font-awesome-icon icon="plus"/> create playlist
        </b-button>
      </template>
      <template slot="mobileCmd" slot-scope="{}">
        <b-nav-item :to="{name: 'fan-playlist-create'}"><font-awesome-icon icon="plus"/> create playlist</b-nav-item>
      </template>
    </ObjectListTabs>

    <PlaylistList :items="playlists" v-if="playlists.length" />
    <b-row v-if="!playlists.length">
      <b-col class="text-center empty" v-if="$route.meta.type === 'my'">
        You haven't created any playlists yet
      </b-col>
      <b-col class="text-center empty" v-else>
        You aren't following any playlists yet
      </b-col>
    </b-row>
  </b-container>
</template>

<style scoped lang="scss">
  @import '@/assets/custom.scss';

  .container {
    margin-top: 1em;
  }

  .headline {
    /* padding-bottom: 1em; */
    /* margin-bottom: 1em; */
    /* border-bottom: 1px solid $warm-grey; */

    h4 {
        display: inline-block;
        margin-right: 1em;
        color: $steel;

        &.active {
            color: $white;
        }
    }

    button {
        padding-left: 1em;
        padding-right: 1em;
    }

  }

  .empty {
    text-align: center;
    margin-top: 1em;
    color: $steel;
  }
</style>

<script>
import FontAwesomeIcon from '@fortawesome/vue-fontawesome'
import PlaylistList from '@/components/widgets/PlaylistList'
import ObjectListTabs from '@/components/widgets/ObjectListTabs'
import Headline from '@/components/widgets/Headline'

import { mapGetters } from 'vuex'

export default {
  name: 'MyPlaylists',
  components: {
    FontAwesomeIcon,
    PlaylistList,
    ObjectListTabs,
    Headline
  },
  data () {
    return {
      playlists: []
    }
  },
  computed: {
    ...mapGetters('profile', ['currentUser'])
  },
  watch: {
    '$route': 'initPage'
  },
  created () {
    this.initPage()
  },
  methods: {
    async initPage () {
      let filter
      if (this.$route.meta.type === 'following') {
        filter = { follower_id: this.currentUser.id }
      } else {
        filter = { profile_id: this.currentUser.id }
      }

      const response = await this.$store.dispatch('playlist/listPlaylists', filter)
      this.playlists = await response.all()
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/fan/PlaylistList.vue